__turbopack_context__.v({
  "className": "outfit_2191e7c1-module__QgUyxW__className",
  "variable": "outfit_2191e7c1-module__QgUyxW__variable",
});
